import { $window } from '../../helpers/globalVars';

const handler = ( $ ) => {
	const $share = $( '.share' );
	const $dropdown = $( '.share__dropdown', $share );

	if ( $share.length == 0 || $dropdown.length == 0 ) {
		return;
	}

	const showDropdown = ( $_dropdown ) => {
		$_dropdown.fadeIn().attr( 'data-is-visible', 'yes' );
	};

	const hideDropdown = ( $_dropdown ) => {
		$_dropdown.fadeOut().attr( 'data-is-visible', 'no' );
	};

	const shareClickHandler = function ( e ) {
		const $this = $( this ),
			$thisDropdown = $( '.share__dropdown', $this ),
			isHiddenThisDropdown =
				$thisDropdown.attr( 'data-is-visible' ) == 'no',
			isDropdownOutClick =
				! $dropdown.is( e.target ) &&
				$dropdown.has( e.target ).length == 0;

		if ( isHiddenThisDropdown ) {
			showDropdown( $thisDropdown );
		} else if ( isDropdownOutClick ) {
			hideDropdown( $thisDropdown );
		}
	};

	const windowClickHandler = ( e ) => {
		const $visibleDropdown = $dropdown.filter( '[data-is-visible="yes"]' ),
			isDropdownOutClick =
				! $dropdown.is( e.target ) &&
				$dropdown.has( e.target ).length == 0,
			isDropdownOpenerOutClick =
				! $share.is( e.target ) && $share.has( e.target ).length == 0;

		if (
			isDropdownOutClick &&
			$visibleDropdown.length != 0 &&
			isDropdownOpenerOutClick
		) {
			hideDropdown( $visibleDropdown );
		}
	};

	$share.on( 'click', shareClickHandler );
	$window.on( 'click', windowClickHandler );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
